module.exports = __webpack_public_path__ + "img/shape-10.88d6fcd3.svg";